import "bootstrap/dist/css/bootstrap.min.css";
import "./Nav.css";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";

function Footer() {
    return (
        <footer className="footer bg-primary text-light pt-5">
            <div className="container">

                <hr className="bg-white" />

                <div className="row">
                    {/* Contact Info with Logo */}
                    <div className="col-md-6 mb-4 text-left text-md-left">
                        <div className="d-flex align-items-center">
                            {/* Logo */}
                            <a href="/" className="me-3">
                                <img 
                                    src="/logo192.png" 
                                    alt="BooksComply Logo" 
                                    style={{ width: '50px', height: '50px' }}
                                />
                            </a>
                            <div>
                                <h2 className="mb-0"><a href="/" className="text-white text-decoration-none">BooksComply</a></h2>
                                <a href="mailto:contact@BooksComply.com" className="text-white">contact@BooksComply.com</a>
                            </div>
                        </div>
                    </div>

                    {/* Services */}
                    <div className="col-md-2 mb-4 text-left text-md-left">
                        <h6 className="font-weight-bold">SERVICES</h6>
                        <ul className="list-unstyled">
                            <li><a href="/bookkeeping" className="text-white">Bookkeeping</a></li>
                            <li><a href="/cfo-advisory" className="text-white">CFO Advisory</a></li>
                            <li><a href="/tax-return" className="text-white">Tax Return</a></li>
                            <li><a href="/usa-company-formation" className="text-white">USA Company Formation</a></li>
                            <li><a href="/zoho-advisory" className="text-white">Zoho Advisory</a></li>
                        </ul>
                    </div>

                    {/* Resources */}
                    <div className="col-md-2 mb-4 text-left text-md-left">
                        <h6 className="font-weight-bold">RESOURCES</h6>
                        <ul className="list-unstyled">
                            <li><a href="/blog" className="text-white">Blog</a></li>
                            <li><a href="/help" className="text-white">Help Center</a></li>
                        </ul>
                    </div>

                    {/* Legal */}
                    <div className="col-md-2 mb-4 text-left text-md-left">
                        <h6 className="font-weight-bold">LEGAL</h6>
                        <ul className="list-unstyled">
                            <li><a href="/privacy-policy" className="text-white">Privacy Policy</a></li>
                            <li><a href="/subscription-agreement" className="text-white">Subscription Agreement</a></li>
                        </ul>
                    </div>
                </div>
                
                {/* Social Media Icons - Left on mobile, right on desktop */}
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-start justify-content-md-end" style={{ gap: '15px' }}>
                            <a href="https://www.linkedin.com/company/njpglobal" target="_blank" rel="noopener noreferrer" className="text-white">
                                <FaLinkedin size={24} />
                            </a>
                            <a href="https://x.com/NJP_Advisors" target="_blank" rel="noopener noreferrer" className="text-white">
                                <FaTwitter size={24} />
                            </a>
                            <a href="https://www.facebook.com/njpglobal/" target="_blank" rel="noopener noreferrer" className="text-white">
                                <FaFacebook size={24} />
                            </a>
                            <a href="https://www.instagram.com/bookscomply/" target="_blank" rel="noopener noreferrer" className="text-white">
                                <FaInstagram size={24} />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="row mt-3 pt-3 border-top border-light">
                    <div className="col-12 text-center">
                        <p className="mb-2">
                            &copy; {new Date().getFullYear()} NJP Global Services Pvt. Ltd. All Rights Reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );     
}

export default Footer;